import React from 'react';
import AppShell from '../shell/AppShell';
import PricingScreen from '../../screens/PricingScreen';

/**
 * /unified/pricing — renders the production `PricingScreen` inside the
 * unified AppShell. The feat-branch version pointed at a standalone
 * `DinerPricingScreen` that only existed on that branch; swapped for
 * the production `PricingScreen` during the 2026-04-23 reconciliation.
 */
export default function UnifiedPricing() {
  return (
    <AppShell dense>
      <PricingScreen />
    </AppShell>
  );
}
